import { FaStar } from "react-icons/fa";
import { useState } from "react";

const ReviewFormModal = ({
  onClose,
  reviewForm,
  setReviewForm,
  handleReviewSubmit,
  preview,
  handleImageChange,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await handleReviewSubmit(e);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose} // click outside to close
    >
      <div
        className="bg-white w-full max-w-lg rounded-xl p-6 relative overflow-y-auto max-h-[90vh]"
        onClick={(e) => e.stopPropagation()} // prevent modal close when clicking inside
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-black text-lg md:text-xl"
        >
          ✕
        </button>

        <h3 className="text-xl font-semibold mb-6 text-center md:text-left">
          Write a Review
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5">
          {/* Name */}
          <input
            type="text"
            placeholder="Your Name *"
            value={reviewForm.name}
            onChange={(e) =>
              setReviewForm({ ...reviewForm, name: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 text-sm md:text-base focus:ring-2 focus:ring-black outline-none"
            required
          />

          {/* Email */}
          <input
            type="email"
            placeholder="Your Email *"
            value={reviewForm.email}
            onChange={(e) =>
              setReviewForm({ ...reviewForm, email: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 text-sm md:text-base focus:ring-2 focus:ring-black outline-none"
            required
          />

          {/* Rating */}
          <div>
            <p className="mb-2 text-sm font-medium">Your Rating</p>
            <div className="flex gap-2 text-xl cursor-pointer">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  className={
                    star <= reviewForm.rating ? "text-black" : "text-gray-300"
                  }
                  onClick={() =>
                    setReviewForm({
                      ...reviewForm,
                      rating: star,
                    })
                  }
                />
              ))}
            </div>
          </div>

          {/* Comment */}
          <textarea
            placeholder="Write your review..."
            rows="4"
            value={reviewForm.comment}
            onChange={(e) =>
              setReviewForm({ ...reviewForm, comment: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 text-sm md:text-base focus:ring-2 focus:ring-black outline-none resize-none"
            required
          ></textarea>

          {/* Add Photos */}
          <label className="text-sm font-medium block mb-1">Add Photos</label>
          <input type="file" multiple onChange={handleImageChange} />

          {/* Preview */}
          {preview.length > 0 && (
            <div className="flex gap-2 flex-wrap mt-2">
              {preview.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  className="w-16 h-16 object-cover rounded"
                  alt={`preview-${i}`}
                />
              ))}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="bg-black text-white w-full py-2 md:py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            ) : (
              "Submit Review"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReviewFormModal;